var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33741 3.53744C5.29921 3.49721 5.25809 3.46006 5.2142 3.42657L1.47378 0.573032C1.0588 0.256446 0.552972 0.387534 0.343989 0.865827C0.135007 1.34412 0.302003 1.9885 0.716985 2.30508L3.41797 4.36564L0.716985 6.4262C0.302003 6.74279 0.135007 7.38716 0.343989 7.86546C0.552972 8.34375 1.0588 8.47484 1.47378 8.15825L5.2142 5.30471C5.25809 5.27123 5.29921 5.23407 5.33741 5.19384C5.43959 5.11587 5.52609 5.00569 5.5872 4.86583C5.65488 4.71093 5.68313 4.53861 5.67628 4.36564C5.68313 4.19268 5.65488 4.02036 5.5872 3.86546C5.52609 3.72559 5.43959 3.61542 5.33741 3.53744Z",
    fill: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFilter);
export default __webpack_public_path__ + "static/media/arrow-filter.f36e20faf6a800d46f249f8ec8d5eb44.svg";
export { ForwardRef as ReactComponent };